import axiosClient from './axiosClient';
import { ProjectEnvironmentModel } from '../Models/projectEnvironmentModel';

const projectEnvironmentService = {
  getAll: () => {
    return axiosClient.get('/ProjectEnvironment')
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("GET /ProjectEnvironment returned 404. Falling back to GET /project-environments...");
          return axiosClient.get('/project-environments');
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const rawList = res?.data?.data || res?.data || [];
        const mappedList = (Array.isArray(rawList) ? rawList : []).map(ProjectEnvironmentModel.toFrontend);
        return {
          data: mappedList,
        };
      });
  },

  getById: (environmentID) => {
    return axiosClient.get(`/ProjectEnvironment/${environmentID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`GET /ProjectEnvironment/${environmentID} returned 404. Falling back to GET /project-environments/${environmentID}...`);
          return axiosClient.get(`/project-environments/${environmentID}`);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: ProjectEnvironmentModel.toFrontend(raw),
        };
      });
  },

  create: (payload) => {
    const body = ProjectEnvironmentModel.toBackend(payload);
    body.environmentId = 0;

    return axiosClient.post('/ProjectEnvironment', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("POST /ProjectEnvironment returned 404. Falling back to POST /project-environments...");
          return axiosClient.post('/project-environments', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: ProjectEnvironmentModel.toFrontend(raw),
        };
      });
  },

  update: (environmentID, payload) => {
    const body = ProjectEnvironmentModel.toBackend({ ...payload, environmentID });

    return axiosClient.put('/ProjectEnvironment', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("PUT /ProjectEnvironment returned 404. Falling back to PUT /project-environments...");
          return axiosClient.put('/project-environments', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: ProjectEnvironmentModel.toFrontend(raw),
        };
      });
  },

  remove: (environmentID) => {
    return axiosClient.delete(`/ProjectEnvironment/${environmentID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`DELETE /ProjectEnvironment/${environmentID} returned 404. Falling back to DELETE /project-environments/${environmentID}...`);
          return axiosClient.delete(`/project-environments/${environmentID}`);
        }
        return Promise.reject(err);
      });
  },
};

export default projectEnvironmentService;
